<template>
  <div class="sidenavright-menu">
    <div class="sidenavright-content">
      <div class="pill">
        <div class="pill-header">
          <div class="row no-margin">
            <div class="col no-padding">
              <div class="pill-title">
                {{ $t('PAY_UPDATE_INDENT') }}
              </div>
            </div>
            <div class="col-md-auto no-padding bgclose">
              <div class="close-sidebar">
                <svgicon name="cancelwhite" width="14" height="14"
                  :original="true" @click="closeMenu" />
              </div>
            </div>
          </div>
        </div>
        <form>
          <div v-if="indentDetails">
            <div class="pill-body">
              <div class="pill-row">
                <div class="row">
                  <div class="col-5">
                    <div class="pill-primarytext">
                      {{indentDetails.order_reference}}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="pill-sectext">
                      {{ $t('PAY_ROUTE') }}:
                      <b>
                        <span v-if="getIndentRoute.tooltip">
                          <Tooltip class="item" effect="dark" placement="bottom">
                            <div slot="content" class="tooltipcontent">
                              {{getIndentRoute.tooltip}}
                            </div>
                            <button><span>{{getIndentRoute.route}}</span></button>
                          </Tooltip>
                        </span>
                        <span v-else>{{getIndentRoute.route}}</span>
                      </b>
                    </div>
                    <div v-if="showTruckType" class="pill-sectext">
                      {{ $t('PAY_VEHICLE_TYPE') }}: <b>{{indentDetails.truck_type}}</b>
                    </div>
                    <div class="pill-sectext" v-if="indentDetails.po_number">
                      {{ $t('PAY_PO_NUMBER') }}: <b>{{indentDetails.po_number}}</b>
                    </div>
                     <div class="pill-sectext" v-if="indentDetails.account_assignment_number">
                       {{ $t('PAY_ACC_ASSGN_NO') }}: <b><ellipsis
                    :text="indentDetails.account_assignment_number"
                    :length="6"
                    /></b>
                    </div>
                  </div>
                  <div class="col-md-6 text-right">
                    <div class="pill-sectext list-badge" v-if="indentMaterial">
                      <div v-if="indentMaterial.weight && indentMaterial.volume">
                        <span class="badge">{{ $t('WEIGHT_SHORT_FORM') }}</span>
                        {{indentMaterial.weight.value.toFixed(2)}} {{indentMaterial.weight.unit}}
                        <span class="badge">{{ $t('VOLUME_SHORT_FORM') }}</span>
                        {{getConvertedClientVolume(indentMaterial.volume.value.toFixed(2))}} {{preferredVolumeUnit.toLowerCase()}}
                      </div>
                    </div>
                    <div class="pill-sectext" v-if="indentDetails.truck_reference">
                      {{ $t('VEHICLE_NO') }}: <b>{{indentDetails.truck_reference}}</b>
                    </div>
                  </div>
                </div>
              </div>
              <div class="collapsesection">
                <Collapse v-model="activeName" accordion @change="setGAEvent">
                  <CollapseItem :title="$t('PAY_PHYSICAL_LR')" name="1">
                    <div v-if="!isPhysicalLR">
                      <div class="centerblockimg w100p">
                        <svgicon name="lr-notavailable" width="100px" height="195px"
                          :original="true" />
                      </div>
                    </div>
                    <div v-else>
                      <PhysicalLr
                        v-for="consignee in indentDetails.consignee_lr_data"
                        :consignee="consignee"
                        :indentID="indentDetails.order_no"
                        :key="consignee.id"
                        @addLRAttachments="addLRAttachments(consignee, $event)"
                        @removeLRAttachments="removeLRAttachments(consignee, $event)"
                        @updateDocument="updateDocument" />
                    </div>
                  </CollapseItem>
                  <CollapseItem :title="$t('CHARGES')" name="2">
                    <div class="subcollapse collapse-sec">
                      <Collapse accordion>
                        <div v-for="(consignee,index) in indentDetails.consignee_data"
                          :key = "index">
                          <div v-if="consignee.charges">
                            <div v-if="isPTLIndentType">
                              <CollapseItem
                                v-if="consignee.charges"
                                :title="consignee.name">
                                <charge-details
                                  :paymentSettings="currentClientConfig.payment_settings"
                                  :enablePayInDispatch="currentClientConfig.payment_in_dispatch_status && currentClientConfig.payment_in_dispatch_status.enabled"
                                  :filteredChargesHeaders="getChargesHeaders"
                                  :consigneeDetails="consignee"
                                  :chargeComments="chargeComments[consignee.id]"
                                  :editable="true"
                                  :indent="indentDetails"
                                  :paymentId="indentDetails.id"
                                  :consigneeDataId="consignee.id"
                                  :orderType="indentDetails.order_type"
                                  :showTransporterDebit="false"
                                  :chargesFixedHeight="false"
                                  :showSave="false"
                                   @updateChange="updateTempConsignee"
                                  />
                              </CollapseItem>
                            </div>
                            <div v-else class="spacingcard">
                              <charge-details
                              :paymentSettings="currentClientConfig.payment_settings"
                              :enablePayInDispatch="currentClientConfig.payment_in_dispatch_status && currentClientConfig.payment_in_dispatch_status.enabled"
                              :filteredChargesHeaders="getChargesHeaders"
                              :consigneeDetails="consignee"
                              :chargeComments="chargeComments[consignee.id]"
                              :editable="true"
                              :indent="indentDetails"
                              :paymentId="indentDetails.id"
                              :consigneeDataId="consignee.id"
                              :orderType="indentDetails.order_type"
                              :showTransporterDebit="false"
                              :chargesFixedHeight="false"
                              :showSave="false"
                              :clientConfig="currentClientConfig"
                              @updateChange="updateTempConsignee"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="spacingcard" v-if="isPTLIndentType">
                          <div class="row align-items-center bggrey">
                            <div class="col-7 grid-title resulttext">{{ $t('TOTAL_AMOUNT') }} </div>
                            <div class="col-3 resultvalue grid-count">
                              <span v-if="totalAmount === 0">{{totalAmount}}</span>
                              <span v-else-if="totalAmount && totalAmount!== NaN">
                                {{totalAmount}}
                              </span>
                            </div>
                          </div>
                        </div>
                      </Collapse>
                    </div>
                  </CollapseItem>
                </Collapse>
              </div>
            </div>
          </div>
            <div v-else>{{$t('INDENT_ORDER_LOADING')}}</div>
        </form>
        <div class="formfooter px-15" :style="inlineManualEnabled ? `height:95px` : ``">
          <button class="btn section_obtn" @click="prev()" v-if="!isFirstIndent">{{ $t('PREVIOUS') }}</button>
          <div class="btnaction">
            <Button type="primary" size="mini" @click="update">{{ $t('UPDATE') }}</Button>
            <button class="btn section_sbtn" @click="next()" v-if="!isLastIndent">{{ $t('NEXT') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { mapGetters } from 'vuex';
import PhysicalLr from '@/components/common/UpdateFiles/PhysicalLr';
import SecComments from '@common/components/SecComments';
import Attachments from '@common/components/Attachments';
import chargesHeaders from '@common/constants/IndentCharges';
import ellipsis from '@common/components/Ellipsis';
import { getRouteByDepot, getMaterialDetails, getTransporterCharges,
  isPTLIndentType, isOpenOrder } from '@common/lib/payments';
import Amounts from './Amounts';
import ChargeDetails from './ChargeDetails';
import VolumeFormulaConvertor from '../../../../../common-v2/helpers/volume-formula-converter';

export default {
  props: {
    indentDetails: {
      type: Object,
      default: () => {},
    },
    isFirstIndent: {
      type: Boolean,
      default: false,
    },
    isLastIndent: {
      type: Boolean,
      default: false,
    },
    chargeComments: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    PhysicalLr,
    SecComments,
    Attachments,
    Amounts,
    ellipsis,
    ChargeDetails,
  },
  data() {
    return {
      chargesHeaders,
      isOpen: false,
      temporaryConsigneeData: [],
      activeName: '1',
    };
  },
  computed: {
    ...mapGetters({
      payments: 'paymentsV2/list',
      tempCharges: 'paymentsV2/tempCharges',
      currentClient: 'app/currentClient',
      currentClientConfig: 'app/currentClientConfig',
    }),
    inlineManualEnabled() {
      return this.currentClientConfig && this.currentClientConfig.inline_manual
        && this.currentClientConfig.inline_manual.transporter_api_key;
    },
    showTruckType() {
      return this.currentClientConfig.payment_settings &&
        !this.currentClientConfig.payment_settings.hide_transporter_truck_type;
    },
    getIndentComments() {
      const comments = this.indentDetails.comments;
      comments.sort((a, b) =>
        // eslint-disable-next-line no-nested-ternary
        ((a.created_at > b.created_at) ? 1 : ((b.created_at > a.created_at) ? -1 : 0)));
      return comments;
    },
    isPTLIndentType() {
      return this.indentDetails && isPTLIndentType(this.indentDetails.delivery_type);
    },
    openOrderBool() {
      return !!(this.indentDetails && isOpenOrder(this.indentDetails.order_type));
    },
    getIndentRoute() {
      const result = getRouteByDepot(this.indentDetails);
      const tooltip = result.multidropCities;
      const route = result.source.concat(' to ', result.destination);
      return { route, tooltip };
    },
    indentMaterial() {
      return getMaterialDetails(this.indentDetails);
    },
    isPhysicalLR() {
      return this.indentDetails && this.indentDetails.consignee_data &&
        this.indentDetails.consignee_data.length > 0;
    },
    getAttachments() {
      return this.indentDetails && this.indentDetails.attachments.map(attachment => ({
        name: attachment.content_file_name,
        url: attachment.metadata.location,
        id: attachment.id }));
    },
    totalAmount() {
      let total = 0;
      if (this.indentDetails) {
        this.indentDetails.consignee_data.forEach((consignee) => {
          if (consignee.charges) {
            const transporterCharges = getTransporterCharges(consignee.charges);
            total += this.tempCharges[consignee.id] ? this.tempCharges[consignee.id].total_amount :
              transporterCharges.total_amount;
          }
        });
      }
      return total;
    },
    getChargesHeaders() {
      const { payment_settings: paymentSettings } = this.currentClientConfig;
      let headers = this.chargesHeaders;
      const customCharges = this.indentDetails.custom_charges || [];
      if (paymentSettings && paymentSettings.payment_charges_column_display) {
        headers = headers.filter(header =>
          paymentSettings.payment_charges_column_display[header.column]);
      }
      // manually adding custom chargee headers
      if (customCharges.length) {
        const lastHeaderId = headers.reduce((acc, header) => (header.id > acc ? header.id : acc), 0);
        customCharges.forEach((chargeDetails, i) => {
          // PAN-41722: SAP charges override - force editable for SAP clients
          const isReadOnly = this.isSapChargeEnabled ? false : (!chargeDetails.is_editable || false);
          headers.push({ id: lastHeaderId + i + 1, column: `custom_${chargeDetails.name}`, class: 'w100', label: chargeDetails.label, tlabel: chargeDetails.label, readOnly: isReadOnly });
        });
      }
      return headers;
    },
    preferredVolumeUnit() {
      return this.$preferredVolumeUnit();
    },
    isSapChargeEnabled() {
      return this.currentClient && this.currentClient.features &&
        this.currentClient.features.includes('sap_charge_integration');
    },
  },
  methods: {
    getConvertedClientVolume(volume) {
      const volumeInClientUnit = new VolumeFormulaConvertor().revertToClient(this.preferredVolumeUnit, volume);
      return volumeInClientUnit;
    },
    initTemporaryDetails() {
      this.temporaryConsigneeData = [];
    },
    async addComments(comment) {
      const data = { comment };
      const result = await this.$store.dispatch('paymentsV2/updateComment',
        { id: this.indentDetails.id, data });
      if (result.data) {
        this.$emit('addIndentDetails', result.data, 'comments');
      }
    },
    async addAttachments(file) {
      const formData = new FormData();
      formData.append('attachment', file.raw);
      const result = await this.$store.dispatch('paymentsV2/updateAttachment',
        { paymentId: this.indentDetails.id, formData });
      if(result && result.error){
        this.$errorMessage({ message: result.error || this.$getErr('UPLOAD_FAILS')});
      } else if (result.data) {
        this.$emit('addIndentDetails', result.data, 'attachments');
      }
    },
    async removeAttachments(file) {
      await this.$store.dispatch('paymentsV2/deleteAttachment', { attachmentId: file.id });
      this.$emit('removeIndentDetails', file.id, 'attachments');
    },
    addLRAttachments(currentConsignee, attachment) {
      const consigneeData = this.indentDetails.consignee_lr_data.map((consignee) => {
        const result = consignee;
        if (this.currentClientConfig.multi_drop_at_gate_level) {
          if (result.consignee_id === currentConsignee.consignee_id &&
            result.destination_gate_id === currentConsignee.destination_gate_id) {
            result.attachments.push(attachment);
            if (result.lorry_receipts) {
              result.lorry_receipts = result.lorry_receipts.map((lr) => {
                const item = lr;
                item.document_available = true;
                return item;
              });
            }
          }
        } else if (result.consignee_id === currentConsignee.consignee_id) {
          result.attachments.push(attachment);
          if (result.lorry_receipts) {
            result.lorry_receipts = result.lorry_receipts.map((lr) => {
              const item = lr;
              item.document_available = true;
              return item;
            });
          }
        }
        return result;
      });
      this.updateLR(consigneeData);
    },
    async removeLRAttachments(currentConsignee, fileId) {
      const consigneeData = this.indentDetails.consignee_lr_data.map((consignee) => {
        const result = consignee;
        if (result.id === currentConsignee.id) {
          result.attachments = result.attachments.filter(attachment =>
            attachment._id !== fileId);
        }
        return result;
      });

      // If no attachments left, toggle all LRs to "No" (document_available = false)
      const affectedConsignee = consigneeData.find(c => c.id === currentConsignee.id);
      if (affectedConsignee && affectedConsignee.attachments.length === 0 &&
          affectedConsignee.lorry_receipts) {
        const lorryReceipts = affectedConsignee.lorry_receipts.map(lr =>
          this.buildLorryReceiptPayload(affectedConsignee, lr, false));
        await this.updateDocument(lorryReceipts);
      }

      this.updateLR(consigneeData);
    },
    buildLorryReceiptPayload(consignee, lr, documentAvailable) {
      const recieptsResponse = {
        destination_id: consignee.consignee_id,
        source_location_id: consignee.depot_id,
        lr_number: lr.lr_number,
        document_available: documentAvailable,
      };
      if (lr.legal_entity) {
        recieptsResponse.legal_entity = lr.legal_entity;
      }
      if (lr.source_gate_id) {
        recieptsResponse.source_gate_id = lr.source_gate_id;
      }
      if (this.currentClientConfig.multi_drop_at_gate_level && consignee.destination_gate_id) {
        recieptsResponse.gate_id = consignee.destination_gate_id;
      }
      return recieptsResponse;
    },
    updateLR(consigneeData) {
      this.$emit('updatePaymentDetails', consigneeData, 'consignee_data');
      let documentAvailable = consigneeData.every(
        consignee => consignee.attachments.length > 0);
      this.$emit('updatePaymentDetails', documentAvailable, 'lr_attachment_available');
      documentAvailable = consigneeData.every(
        consignee => consignee.lorry_receipts.every(lr => lr.document_available));
      this.$emit('updatePaymentDetails', documentAvailable, 'all_physical_documents_available');
    },
    async updateDocument(lorryReceipts) {
      const result = await this.$store.dispatch('paymentsV2/updateDocument', {
        orderNo: this.indentDetails.order_no, lorryReceipts });
      if (result && result.data) {
        this.$emit('updatePaymentDetails', result.lorry_receipts, 'lorry_receipts');
        this.updateLR(this.indentDetails.consignee_lr_data);
      }
    },
    updateTempConsignee(data) {
      const index = this.temporaryConsigneeData.findIndex(consignee =>
        consignee.id === data.id);
      if (index === -1) {
        this.temporaryConsigneeData.push(data);
      } else {
        this.temporaryConsigneeData[index] = data;
      }
    },
    /** find and push in a array of simple objects */
    findAndPush(array, idColumn, data) {
      const result = array;
      const index = array.findIndex(item => item[idColumn] === data[idColumn]);
      if (index === -1) {
        result.push(data);
      } else {
        const newObj = { ...array[index], ...data };
        result[index] = newObj;
      }
      return result;
    },
    closeMenu() {
      this.$emit('close');
      this.initTemporaryDetails();
      this.$store.commit('paymentsV2/setTempCharges', {});
      this.toggleBodyClass('removeClass', 'no-scroll');
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    prev() {
      this.$emit('previousIndent');
      this.initTemporaryDetails();
      this.$store.commit('paymentsV2/setTempCharges', {});
    },
    next() {
      this.$emit('nextIndent');
      this.initTemporaryDetails();
      this.$store.commit('paymentsV2/setTempCharges', {});
    },
    setGAEvent(name) {
      if (name === '2') { // denotes the comments tab(second tab)
        this.$emit('setGA', 'Click', 'Comments & Attachments Tab');
      } else if (name === '3') { // denotes amounts tab(third tab)
        this.$emit('setGA', 'Click', 'Amounts Tab');
      }
    },
    async update() {
      try {
        const payload = {
          id: this.indentDetails.id,
          consignee_data: this.temporaryConsigneeData,
          comments: [],
          attachments: [],
        };
        const response = await this.$store.dispatch('paymentsV2/updatePaymentCharge', payload);
        if (response && response.error) {
          this.$errorMessage({ message: response.error });
        } else {
          this.$successMessage({ message: this.$getSuccess('UPDATE_SUCCESS') });
          this.initTemporaryDetails();
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('UPDATE_FAILURE') });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.spacingcard{
  padding: 0 20px;
}
</style>
